import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'yesNo',
  standalone: true,
  pure: false,
})

/* This class is responsible for Display Yes/No instead of true/false */
export class YesNoPipe implements PipeTransform {

  constructor( private translate: TranslateService){
  }
  transform(value: any, ...args: any[]): any {
    return value ? this.translate.instant('true'):this.translate.instant('false');
  }

}
